<div class="mx-auto px-4">
  <div class="overflow-x-auto">
    <div class="mb-4">
      <p id="gestion-des-bibliotheques" class="titre1 mt-4">
        {{ 'LIBRARIES_MANAGEMENT.LIBRARIES_MANAGEMENT' | translate }}
        <mat-icon
        class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">books_movies_and_music</mat-icon>
      </p>
    </div>

    @if (isLoading) {
      <div class="flex justify-center items-center h-64">
        <mat-spinner color="accent"></mat-spinner>
      </div>
    }

    @if (!isLoading) {
      <div class="flex justify-end mb-4">
        <button (click)="createBibliotheque()"
          class="bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-buttonAction">
          {{ 'LIBRARIES_MANAGEMENT.CREATE_LIBRARY' | translate }}
        </button>
      </div>
      <div class="flex justify-end mb-4 gap-3">
        <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()"
          placeholder="{{ 'LIBRARIES_MANAGEMENT.SEARCH' | translate }}..."
          class="w-8 w-80 rounded-md border-w-2 border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200">
          <button mat-icon-button (click)="reinitialiserFiltre()"
            class="h-1/12 w-8 bg-white-200 text-white-600 rounded">
            <mat-icon>restore</mat-icon>
          </button>
        </div>
        <div class="w-full overflow-x-auto">
          <table mat-table [dataSource]="dataSource" matSort class="mat-table-novo">
            <ng-container matColumnDef="nom">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-3/5 table-cell px-4 py-2">
                {{ 'LIBRARIES_MANAGEMENT.NAME' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="w-3/5 table-cell px-4 py-2 border-b">
                {{ getBibliothequeLocalizedName(element) }}
              </td>
            </ng-container>
            <ng-container matColumnDef="totalPackages">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-1/5 table-cell px-4 py-2">
                {{ 'LIBRARIES_MANAGEMENT.TOTAL_PACKAGES' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="w-1/5 table-cell px-4 py-2 border-b">
                {{ element.totalPackages }}
              </td>
            </ng-container>
            <ng-container matColumnDef="dateCreation">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-1/5 table-cell px-4 py-2">
                {{ 'LIBRARIES_MANAGEMENT.CREATION_DATE' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="w-1/5 table-cell px-4 py-2 border-b">
                {{ element.dateCreation | dateFormat }}
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="w-1/10 table-cell px-4 py-2 text-center">
                {{ 'LIBRARIES_MANAGEMENT.ACTIONS' | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let i = index"
                class="w-1/10 table-cell px-4 py-2 border-b text-center">
                <div class="menu-container">
                  <button (click)="toggleMenu(i)"
                    class="bg-grey-500 hover:bg-grey-700 font-bold py-2 px-4 border-none hover:text-red-700 transform scale-90 sm:scale-100">
                    <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                  </button>
                  @if (element.isMenuOpen) {
                    <div
                      class="absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                      <div class="py-1" role="menu" aria-orientation="vertical"
                        aria-labelledby="options-menu">
                        <a href="javascript:void(0)"
                          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                          role="menuitem" (click)="editBibliotheque(element)">
                          {{ 'LIBRARIES_MANAGEMENT.EDIT' | translate }}
                        </a>
                      </div>
                      <div class="py-1" role="menu" aria-orientation="vertical"
                        aria-labelledby="options-menu">
                        <a href="javascript:void(0)"
                          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                          role="menuitem" (click)="openDeleteDialog(element)">
                          {{ 'LIBRARIES_MANAGEMENT.REMOVE' | translate }}
                        </a>
                      </div>
                    </div>
                  }
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          @if (dataSource.filteredData.length === 0) {
            <div class="text-center mt-2 text-gray-500">
              {{ 'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}
            </div>
          }
          <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
            (page)="paginer($event)" [length]="dataSource.filteredData.length" [showFirstLastButtons]="true">
          </mat-paginator>
        </div>
      }
    </div>
  </div>